export const adminPermissions = {
  'facin.shares.get': true,
  'facin.shares/:uuid.get': true,
  'facin.shares.post': true,
  'facin.shares.put': true,
};

export const managerPermissions = [];
